<template>
    <e-tooltip :label="label" multilined :position="item.position" size="is-large">
        <e-icon :icon="item.icon || 'lock'" custom-class="is-disabled" class="align-icon" />
    </e-tooltip>
</template>

<script>
export default {
    name: 'LockedItem',

    props: {
        // TODO: Refactor to individual props
        item: {
            default: null,
            type: Object,
            required: true,
        },
    },

    computed: {
        label() {
            if (this.item.type === 'prerequisite') {
                return this.prerequisite;
            }

            if (this.item.type === 'visibleAt') {
                return this.item.visibleAt;
            }

            return `This ${this.type.toLowerCase()} is locked`;
        },

        type() {
            if (this.item.namespace !== 'Week Break') {
                this.item.namespace.toLowerCase();

                return this.item.namespace.includes('act') ? 'Activity' : 'Section';
            }

            if (this.item.type === 'break') {
                return this.item.type;
            }

            return this.item.namespace;
        },

        prerequisite() {
            return `This ${this.type} is locked until ${this.item.prereqTitle} is completed.`;
        },
    },
};
</script>
<style scoped>
.align-icon {
    position: relative;
    top: -1px;
}
</style>
